import ShiftOperatorsWidget from "./ShiftOperatorsWidget";

export default ShiftOperatorsWidget